export const DEFAULT_LOCALE = 'en-AU' as const
export const GERMAN_LOCALE = 'de-DE' as const

export function getCountryCodeFromLocale(locale: string): string {
  return new Intl.Locale(locale).region ?? ''
}
